import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipmentStopTypes } from '../common/CommonActions';
import { getShipmentStopTypes } from '../shipment/ShipmentEffects';

const useShipmentStopType = () => {
  const [list, setList] = useState(undefined);
  const { shipmentStopTypes } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shipmentStopTypes.success) {
      setList(shipmentStopTypes.data);
    } else {
      getList();
    }
  }, [shipmentStopTypes]);

  const getList = async () => {
    try {
      dispatch(setShipmentStopTypes({ success: true, data: [] }));
      const { data } = await getShipmentStopTypes();
      setList(data);
      dispatch(setShipmentStopTypes({ success: true, data }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useShipmentStopType;
